import {
  ApiRoutes,
  Mensagens,
  MotivoContato,
  SituacaoLigacaoAgua,
} from "../../models/types";
import {
  formatarDinheiro,
  getMatriculaSolicitante,
} from "../../utils/functions";
import { useContaUsuario } from "../../contexts/contaUsuarioContext";
import { useEffect, useState } from "react";
import { z } from "zod";
import { useAxiosClient } from "../../hooks/useAxiosClient";
import { useIonLoading } from "@ionic/react";
import { useProtocolo } from "../../contexts/protocoloContext";
import Page from "../../components/Page";
import Accordion from "../../components/Accordion";
import useNotification from "../../hooks/useNotification";
import ReactForm from "../../components/form/ReactForm";
import SubmitButton from "../../components/form/SubmitButton";
import ButtonBack from "../../components/ButtonBack";
import DivFaltaAgua from "../../components/DivFaltaAgua";
import InputComplete from "../../components/form/InputComplete";

export default function SolicitarReligacaoAguaNaConta() {
  const { getProtocolo } = useProtocolo();

  const contaUsuarioContext = useContaUsuario();
  const notification = useNotification();
  const axiosArrecadacao = useAxiosClient(ApiRoutes.ECO_ARRECADACAO);

  const [present, dismiss] = useIonLoading();
  const [listaTaxa, setListaTaxa] = useState<any>();

  useEffect(() => {
    consultarTaxa();
  }, []);

  async function consultarTaxa() {
    await present({ message: Mensagens.CONSULTANDO });

    try {
      const res = await axiosArrecadacao.get(
        `/contas-religacao/taxa-religacao/${contaUsuarioContext?.contaSelecionada?.numeroContaComDigito}`
      );

      if (res?.data?.valorReligacaoNormal) {
        setListaTaxa([
          {
            label: "Normal",
            value: "NORMAL",
            detalhes: `A taxa de religação NORMAL é de ${formatarDinheiro(
              res.data.valorReligacaoNormal
            )} e o prazo para execução é de até 24(vinte e quatro) horas.`,
          },
          {
            label: "De urgência",
            value: "URGENCIA",
            detalhes:
              `A taxa de religação DE URGÊNCIA é de ${formatarDinheiro(
                res.data.valorReligacaoUrgente
              )} e o prazo para execução é de até 6(seis) horas para dias úteis no horário comercial ` +
              "e de até 14(quatorze) horas para feriados, finais de semana e solicitações fora do horário comercial.",
          },
        ]);
      } else {
        await notification.showError({
          message: "Não foi encontrado o valor da taxa.",
        });
      }

      dismiss();
    } catch (e: any) {
      dismiss();

      await notification.showError({ exception: e });
    }
  }

  const formSchema = z.object({
    tipoReligacao: z.string().min(1, "Selecione o tipo de religação."),
  });

  type formType = z.infer<typeof formSchema>;

  async function enviarDados(dados: formType, resetFields: any) {
    //
    if (
      contaUsuarioContext?.contaSelecionada?.codigoSituacaoLigacaoAgua !==
      SituacaoLigacaoAgua.CORTADA
    ) {
      notification.showAlert({
        message: Mensagens.MSGE0103_SEM_REGISTRO_CORTE,
      });
      return;
    }

    await present({ message: Mensagens.SALVANDO });

    const protocolo = await getProtocolo({
      numeroConta: contaUsuarioContext?.contaSelecionada?.numeroConta || null,
      dddTelefoneContato: null,
      numeroTelefoneContato: null,
      codigoMotivoContato: MotivoContato.RELIGACAO_DE_AGUA,
    });

    if (!protocolo || !protocolo.numeroProtocolo) {
      dismiss();
      return;
    }

    try {
      let body = {
        matriculaSolicitante: getMatriculaSolicitante(),
        numeroContaComDigito:
          contaUsuarioContext?.contaSelecionada?.numeroContaComDigito,
        protocolo: protocolo.numeroProtocolo,
        prazoReligacao: dados.tipoReligacao,
      };

      await axiosArrecadacao.post(
        "/contas-religacao/solicitar",
        JSON.stringify(body),
        {
          headers: {
            "content-type": "application/json",
          },
        }
      );

      notification.showProtocolo(protocolo.numeroProtocolo).then(() => {
        resetFields();
      });

      dismiss();
    } catch (e: any) {
      dismiss();

      await notification.showError({ exception: e });
    }
  }

  return (
    <Page title="Solicitar religação de água" buttonType="back">
      <div className="flex flex-col space-y-4">
        <Accordion title="Observações" open={false}>
          <DivFaltaAgua />
        </Accordion>

        <div className="card bg-opacity-70">
          <div className="card-title">Dados da ocorrência</div>

          <div className="items-center">
            <ReactForm
              schema={formSchema}
              onError={(error, e) => {}}
              onSubmit={(data, resetFields) =>
                enviarDados(data as formType, resetFields)
              }
            >
              <div className="flex flex-col space-y-4">
                <InputComplete
                  showDivDetalhes
                  name="tipoReligacao"
                  placeHolder="Tipo de religação"
                  items={listaTaxa}
                />

                <div className="grid grid-cols-2 gap-2 xs:grid-cols-1">
                  <SubmitButton label="Enviar" />
                  <ButtonBack label="Voltar" />
                </div>
              </div>
            </ReactForm>
          </div>
        </div>
      </div>
    </Page>
  );
}
